export default "__VITE_ASSET__5ba64e9d__"